/**
 * What a refusal reads as on screen.
 *
 * Every failing call on this screen lands in the same place: the SDK store
 * assigns whatever was thrown, and the client rethrows a transport failure
 * unchanged. So `store.error` holds either the server's `{ code, detail }` or a
 * bare `TypeError` from a `fetch` that never connected — and seven templates
 * used to render `code` directly, which drew an empty red bar when the server
 * was simply not there.
 *
 * One function rather than seven copies of the same two lines, because they
 * were seven copies of the same two lines.
 */
export function failureText(failure) {
    if (failure === null || failure === undefined) {
        return ''
    }
    if (failure.code) {
        if (failure.detail) {
            return `${failure.code} — ${failure.detail}`
        }
        return failure.code
    }
    if (failure.message) {
        return failure.message
    }
    return 'The request did not go through.'
}
